@if (showGeolocationRequest()) {
  <section class="register-user__geolocation-request" 
    role="dialog" 
    aria-labelledby="geolocation-title" 
    aria-describedby="geolocation-description"
  >
    <div class="geolocation-request__header-main-wrapper">
      <app-geolocation-request-header />
      <app-geolocation-request-main />
    </div>
    
    <app-geolocation-request-footer 
      (geolocationRequestEmitter)="handleRequestGeolocation($event)" 
    />
  </section>
}